import { render } from "./ConfirmationBanner.vue?vue&type=template&id=37d5e6ee&scoped=true"
import script from "./ConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./ConfirmationBanner.vue?vue&type=script&lang=js"

import "./ConfirmationBanner.vue?vue&type=style&index=0&id=37d5e6ee&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1529448037/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37d5e6ee"]])

export default __exports__